import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { Button } from './ui';
const testimonials = [{
  quote: 'Am venit fără așteptări mari și am plecat cu o claritate pe care nu o mai avusesem de ani de zile. Tehnicile sunt practice, nu teorie goală.',
  name: 'Adrian',
  role: 'Antreprenor'
}, {
  quote: 'După modul 3 am reușit să las în urmă o frică veche care mă bloca în fiecare prezentare. Acum vorbesc în fața oamenilor cu încredere reală.',
  name: 'George',
  role: 'Manager'
}, {
  quote: 'Relația cu echipa mea s-a schimbat complet. Am învățat să ascult altfel și să comunic fără să intru în conflict. Recomand din suflet.',
  name: 'Gianina',
  role: 'Team Leader'
}, {
  quote: 'Cel mai valoros lucru a fost că am înțeles de ce repet aceleași tipare. Acum am instrumente concrete să fac altfel, nu doar intenții.',
  name: 'Mirela',
  role: 'Psiholog'
}];
export const OfferTestimonials = () => {
  return <section className="py-24 bg-[#111936] relative border-y border-gold/10 overflow-hidden" data-id="element-312">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-313">
        <img src="https://images.unsplash.com/photo-1560439514-4e9645039924?auto=format&fit=crop&w=1920&q=80" alt="" className="w-full h-full object-cover opacity-[0.06]" data-id="element-314" />
        <div className="absolute inset-0 bg-[#111936]/90" data-id="element-315" />
      </div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-316">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-317">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-318">
            Ce spun oamenii care au parcurs programul NLP Practitioner
          </h2>
          <div className="w-24 h-px bg-gold mx-auto" data-id="element-319" />
        </motion.div>
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-320">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-navy p-8 md:p-10 relative border border-gold/10 hover:border-gold/30 transition-colors duration-300" data-id="element-321">
              <Quote className="w-12 h-12 text-gold/20 absolute top-8 right-8" data-id="element-322" />
              <div className="flex items-center gap-4 mb-8" data-id="element-323">
                <div className="w-14 h-14 rounded-full bg-navy-card border border-gold/30 flex items-center justify-center" data-id="element-324">
                  <span className="font-display text-gold text-lg font-bold" data-id="element-325">
                    {test.name.charAt(1) || 'P'}
                  </span>
                </div>
                <div data-id="element-326">
                  <h4 className="font-serif text-xl font-bold text-white" data-id="element-327">
                    {test.name}
                  </h4>
                  <p className="font-display text-xs text-textSub uppercase tracking-wider mt-1" data-id="element-328">
                    {test.role}
                  </p>
                </div>
              </div>
              <p className="font-sans text-white italic leading-relaxed text-xl" data-id="element-329">
                "{test.quote}"
              </p>
            </motion.div>)}
        </div>
        <div className="text-center mt-16" data-id="element-330">
          <Button data-id="element-331">Scrie-mi pe WhatsApp pentru detalii!</Button>
        </div>
      </div>
    </section>;
};